import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = { class: "button-container" }
const _hoisted_2 = { class: "flex flex-col md:flex-row justify-center gap-3 button-wrapper" }
const _hoisted_3 = { class: "flex flex-col w-[100%] px-4" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { class: "dialog-footer" }

import { toRefs, ref, watch, computed } from 'vue';

import SelectLiterature from '@/components/selectLiterature.vue'
import PasteLiterature from '@/components/pasteLiterature.vue'
import { Delete } from '@element-plus/icons-vue';
import { Literature } from '@/components/Table/interfaces';

interface Props {
form: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'threeStep',
  props: {
    form: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
const { form } = toRefs(props);
const literatureList = ref<Literature[]>([]);
const isBack = ref(false);

// 检测是否为移动设备
const isMobile = computed(() => {
  return window.innerWidth <= 768;
});

console.log(form.value, 'topicValue')

watch(
  () => form.value.literature,
  (newVal) => {
    if (newVal && JSON.stringify(newVal) !== JSON.stringify(literatureList.value)) {
      literatureList.value = [...newVal];
    }
  },
  { deep: true, immediate: true }
);

watch(
  literatureList,
  (newVal) => {
    // 处理 quote 字段，去除原有[n]并加自增编号
    const processed = newVal.map((item, idx) => ({
      ...item,
      quote: `[${idx + 1}]${item.quote.replace(/^\[\d+\]/, '')}`
    }));
    if (JSON.stringify(processed) !== JSON.stringify(form.value.literature)) {
      form.value.literature = processed;
    }
  },
  { deep: true }
);

const dialogVisible = ref(false)
const pasteVisible = ref(false)

// const pasteLiterature = () => {
//   pasteVisible.value = true
// }

const getUniqueKey = (item: Literature) => `${item.name}-${item.source}`;

const handleDelete = (item: Literature, index: number) => {
  literatureList.value.splice(index, 1)
}

// 监听上一步按钮的点击事件
const handleBack = () => {
  isBack.value = true;
  dialogVisible.value = true;
}

// 监听下一步按钮的点击事件
const handleNext = () => {
  isBack.value = false;
  dialogVisible.value = true;
}

const handleStepChange = (isNext: boolean) => {
    if(isNext) {
        literatureList.value = [];
    }
}

// 暴露方法给父组件
__expose({
  handleBack,
  handleStepChange
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: handleNext,
          disable: literatureList.value.length >= 10,
          class: "mobile-button"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("选择文献")
          ])),
          _: 1
        }, 8, ["disable"])
      ])
    ]),
    _createVNode(_component_el_form_item, {
      name: "literatureList",
      "label-width": "0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(literatureList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex justify-between w-full items-center bg-blue-100 p-3 rounded-md mb-2",
              key: getUniqueKey(item)
            }, [
              _createElementVNode("div", {
                class: "truncate flex-1 mr-3 text-sm",
                title: item.quote
              }, "[" + _toDisplayString(index + 1) + "]" + _toDisplayString(item.quote.replace(/^\[\d+\]/, '')), 9, _hoisted_4),
              _createVNode(_component_el_icon, {
                onClick: ($event: any) => (handleDelete(item, index)),
                class: "cursor-pointer text-red-500"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Delete))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      title: "选择文献",
      width: isMobile.value ? '90%' : '600px',
      class: "mobile-dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false)),
            class: "mobile-dialog-button"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" 选好了 ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(SelectLiterature, {
          modelValue: literatureList.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((literatureList).value = $event)),
          isBack: isBack.value,
          "form-data": _unref(form)
        }, null, 8, ["modelValue", "isBack", "form-data"])
      ]),
      _: 1
    }, 8, ["modelValue", "width"]),
    _createVNode(_component_el_dialog, {
      modelValue: pasteVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pasteVisible).value = $event)),
      title: "粘贴文献",
      width: isMobile.value ? '90%' : '600px',
      class: "mobile-dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (pasteVisible.value = false)),
            class: "mobile-dialog-button"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode(" 选好了 ")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(PasteLiterature, {
          modelValue: literatureList.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((literatureList).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ], 64))
}
}

})